import router from "../router/router.js";
import store from "../store/store.js";
import Vue from "vue";

export default {
    user: {
        authenticated: false,
    },

    signin: function (user, toast) {
        axios
            .post("api/login", user)
            .then((response) => {
                this.dispatchUser(response.data);
                this.setLocalStorage(response.data);
                this.user.authenticated = true;

                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + response.data.token;
                window.location.href = "/";
                //  router.push('/')
            })
            .catch((error) => {
                console.log(error);
                // Mostrar mensaje de error específico para credenciales incorrectas
                if (error.response && error.response.status === 401) {
                    toast.error('Usuario o contraseña incorrectos');
                } else {
                    toast.error('Error de conexión. Inténtalo de nuevo.');
                }
            });
    },

    dispatchUser: function (data) {
        const userData = data.user;
        const token = data.token;

        store.dispatch("auth/setAuthenticated", true);
        store.dispatch("auth/setUserData", {
            id: userData.id,
            name: userData.name,
            email: userData.email,
            role: userData.role,
            role_tfg: userData.role_tfg,
            permissions: userData.permisos,
            token: token
        });
        store.dispatch("auth/setUserDataTemp", {
            id: userData.id,
            name: data.name,
            email: userData.email,
            role: userData.role,
            role_tfg: userData.role_tfg,
            permissions: userData.permisos,
            token: token
        });

        // Solo almacenamos en localStorage datos no sensibles
        localStorage.setItem("user_name", userData.name);
        localStorage.setItem("user_email", userData.email);
        localStorage.setItem("user_id", userData.id);
    },

    setLocalStorage: function (data) {
        const user_id = localStorage.getItem("user_id");
        if ((data.user.role == 1 || data.user.role == 12) && data.user.id != user_id && user_id != null)
            return;
        // Solo guardar el token para autenticación
        localStorage.setItem("id_token", data.token);
        store.dispatch("auth/setUserRole", data.user.role);
        // Los datos del usuario se manejan completamente en Vuex
        // No guardamos datos del usuario en localStorage
    },

    logout: async function (route) {
        try{
            const response = await axios.post("api/logout");
            
            localStorage.removeItem("id_token");
            localStorage.removeItem("user_name");
            localStorage.removeItem("user_email");
            localStorage.removeItem("user_id");
            localStorage.removeItem('permisos');

            // Limpiar todos los datos del usuario del store
            store.dispatch("auth/clearUserData");
            store.dispatch("auth/clearUserDataTemp");
            if(route)router.push("/login");
        }catch(error){
            console.log(error);
        }
    },

    setDefault: function () {
        return {
            name: "...",
        };
    },

    authenticated: function () {
        return this.check();
    },

    check: function () {
        return localStorage.getItem("id_token") !== null ? true : false;
    },
};
